@if (currentStep === ETwoFactorAuthenticationSetupStep.ENTER_PHONE_NUMBER) {
  <pp-two-factor-authentication-number-page
    [(ppPhoneNumber)]="phoneNumber"
    [ppProcessing]="processing"
    (ppStepChange)="goToCodeStep()"
    [(ppChannel)]="channel"
  ></pp-two-factor-authentication-number-page>
}

@if (currentStep === ETwoFactorAuthenticationSetupStep.ENTER_CODE) {
  <pp-two-factor-authentication-code-page
    [ppPhoneNumber]="phoneNumber"
    [ppProcessing]="processing"
    (ppConfirm2FA)="confirm2FA($event)"
    (ppGoBack)="goToNumberStep()"
    [ppErrorMessage]="errorMessage"
    (ppResend)="resendCode()"
  ></pp-two-factor-authentication-code-page>
}

@if (currentStep === ETwoFactorAuthenticationSetupStep.SUCCESS) {
  <pp-two-factor-authentication-success
    (ppContinue)="continueFromSuccess()"
  ></pp-two-factor-authentication-success>
}
